import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./features/auth/authSlices";
import dashboardReducer from "./features/dashbaord/dashboardSlice";
import plansReducer from "./features/plans/plansSlice";
import subscriptionReducer from "./features/subscription/subscriptionSlice";
import companyEmployeeReducer from "./features/company/employee/employeeSlice";
import companyDepartmentReducer from "./features/company/department/departmentSlice";
import companyDesignationReducer from "./features/company/userManagement/designation/designationSlice";
import companyLeaveTypeReducer from "./features/company/leaveManagement/leaveType/leaveTypeSlice";
import companyHolidayReducer from "./features/company/leaveManagement/holiday/holidaySlice";
import companyLeaveDetailsReducer from "./features/company/leaveManagement/leaveDetails/leaveDetailsSlice";
import companySalaryStructureReducer from "./features/company/payrollManagement/salaryStructure/salaryStructureSlice";
import companySalaryConfigurationReducer from "./features/company/payrollManagement/salaryConfiguration/salaryConfigurationSlice";
import processPayrollReducer from "./features/company/payrollManagement/processPayroll/processPayrollSlice";
import attendanceRecordsReducer from "./features/company/attendanceManagement/attendanceRecords/attendanceRecordsSlice";
import themeReducer from "./features/theme/themeSlice";
import rolesReducer from "./features/admin/roleManagement/role/roleSlice";
import permissionsReducer from "./features/admin/roleManagement/permission/permissionSlice";
import roleAccessReducer from "./features/admin/roleManagement/roleAccess/roleAccessSlice";
import companyProjectReducer from "./features/company/projectManagement/project/projectSlice";
import companyTaskReducer from "./features/company/projectManagement/task/taskSlice";
import companyRolesReducer from "./features/company/roleManagement/roleSlice";
import rolePermissionReducer from "store/features/company/roleManagement/rolePermissionSlice";
import employeeRoleReducer from "store/features/company/roleManagement/employeeRoleSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  dashboard: dashboardReducer,
  plans: plansReducer,
  subscription: subscriptionReducer,
  companyEmployee: companyEmployeeReducer,
  companyDepartment: companyDepartmentReducer,
  companyDesignation: companyDesignationReducer,
  companyLeaveType: companyLeaveTypeReducer,
  companyHoliday: companyHolidayReducer,
  companyLeaveDetails: companyLeaveDetailsReducer,
  companySalaryStructure: companySalaryStructureReducer,
  companySalaryConfiguration: companySalaryConfigurationReducer,
  processPayroll: processPayrollReducer,
  attendanceRecords: attendanceRecordsReducer,
  theme: themeReducer,
  roles: rolesReducer,
  companyRoles: companyRolesReducer,
  permissions: permissionsReducer,
  roleAccess: roleAccessReducer,
  companyProject: companyProjectReducer,
  companyTask: companyTaskReducer,
  rolePermissions: rolePermissionReducer,
  companyEmployeeRoles: employeeRoleReducer,
});

export default rootReducer;
